/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { TurJobExecution } from '../../models/tur-job-execution';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface StartJob$Params {
  jobId: string;
  body?: string;
}

export function startJob(
  http: HttpClient,
  rootUrl: string,
  params: StartJob$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TurJobExecution>> {
  const rb = new RequestBuilder(rootUrl, startJob.PATH, 'post');
  if (params) {
    rb.path('jobId', params.jobId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TurJobExecution>;
    }),
  );
}

startJob.PATH = '/manage/job/{jobId}/start';
